import { MrbBaseRouteStore } from "mrb/core";

class FeaturedSectionRouteStore extends MrbBaseRouteStore {
    constructor(rootStore) {
        super(rootStore);
    }
}

export default FeaturedSectionRouteStore;
